export interface ISpecificMapItem { 'identifier': { 'unique': 'true' | 'false' }; 'key': string; 'value': any; }

export class GenericApiRequest<Resource = any> {
  resource: Resource;
  clientSpecificMap: Array<ISpecificMapItem> = [];

  constructor(resource: Resource);
  constructor(resource: Resource, ...mapItems: ISpecificMapItem[]);
  constructor(resource: Resource, ...mapItems: ISpecificMapItem[]) {
    this.resource = resource;
    this.clientSpecificMap.push.apply(this.clientSpecificMap, mapItems);
  }

  getUpdateObject() {
    return { data: this};
  }

}
